import script from "./TermsConditionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsConditionModal.vue?vue&type=script&setup=true&lang=js"

import "./TermsConditionModal.vue?vue&type=style&index=0&id=44e96534&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44e96534"]])

export default __exports__